export const DEFAULT_IDLE_MS = 30 * 60 * 1000;
export const DEMO_IDLE_MS = 8 * 60 * 60 * 1000;

export function inactivityTimeoutMs(demoEnabled, webOrigin, apiUrl) {
  return demoEnabled === 'true' &&
    webOrigin === 'http://127.0.0.1:4696' &&
    apiUrl === 'http://127.0.0.1:4697/api'
    ? DEMO_IDLE_MS
    : DEFAULT_IDLE_MS;
}
